"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentId = void 0;
var ExperimentId;
(function (ExperimentId) {
    // e.g. SHARED_WEB_NEW_NAV_MAP_DESKTOP in
    // https://ab.sc-corp.net/v2/experiment/SHARED_WEB_LOCALIZATION
    ExperimentId["SHARED_WEB_LOCALIZATION"] = "SHARED_WEB_LOCALIZATION";
    // https://ab.sc-corp.net/v2/experiment/WEB_SIGN_IN_ENTRYPOINTS
    ExperimentId["WEB_SIGN_IN_ENTRYPOINTS"] = "WEB_SIGN_IN_ENTRYPOINTS";
})(ExperimentId = exports.ExperimentId || (exports.ExperimentId = {}));
//# sourceMappingURL=experiment.js.map